import React, {Component} from "react"
import {connect, Dispatch} from "react-redux"
import {BlockRefresh, BlockNavigationActions} from "@irati/utils/history/routing"
import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import GenericModal from "@irati/ui/src/GenericModal"
import {H4, Body} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import {ReduxState} from "@irati/store/types"

interface Props extends InjectIntl {
  block: boolean,
  show: boolean,
  unblockNavigation: (bool: boolean) => void,
  trackLeave: () => void
}

class OnLeaveCustomisation extends Component<Props> {
  onLeave = () => {
    const {unblockNavigation, trackLeave} = this.props
    trackLeave()
    unblockNavigation(true)
  }

  hideModal = () => {
    const {unblockNavigation} = this.props
    unblockNavigation(false)
  }

  render() {
    const {block, show} = this.props

    return (
      <BlockRefresh block={block}>
        <GenericModal hideActions show={show} onHide={this.hideModal}>
          <H4>
            <FormattedMessage id="account.customisation.interests.modalHeader" />
          </H4>
          <Body>
            <FormattedMessage id="account.customisation.interests.modalText" />
          </Body>
          <Flex justifyContent="flex-end" marginTop={2}>
            <Button tertiary onClick={this.hideModal}>
              <FormattedMessage id="account.customisation.interests.modalCancel" />
            </Button>
            <Button primary onClick={this.onLeave} marginLeft={2}>
              <FormattedMessage id="account.customisation.interests.modalContinue" />
            </Button>
          </Flex>
        </GenericModal>
      </BlockRefresh>
    )
  }
}

const mapStateToProps = ({blockNavigation}: Dispatch<ReduxState>) => {
  return {
    show: blockNavigation.show
  }
}

const actions = (dispatch: any) => {
  return {
    unblockNavigation: (bool: boolean) => dispatch(BlockNavigationActions.unblock(bool))
  }
}

export default injectIntl(connect(mapStateToProps, actions)(OnLeaveCustomisation))
